import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { ClientsRequest, setCurrentClient, clientSearchChange } from 'client/features/client/actions'
import { getClientsSaga } from 'client/features/client/sagas'
import ClientPreview from 'client/features/client/components/ClientPreview.jsx'
import { browserHistory } from 'react-router'
import { makeEndpoint } from 'client/core/api'
import URLS from 'constant/URLS'
import classNames from 'classnames'
import FontAwesome from 'react-fontawesome'
import _ from 'underscore'
import Select from 'react-select'
import { getSelectReportsOptions, getClientsByFilters } from 'client/features/client/lib'

const Client = ({ client, redirect, active }) =>
    <tr className={ classNames({ active }) }>
        <th scope='row'>
            <a onClick={ redirect.bind(null, client) } className>{ client.name }</a>
        </th>
        <td>
            {
                client.street &&
                    <FontAwesome name={ 'check' }/>
            }
        </td>
        <td>
            {
                client.email &&
                    <FontAwesome name={ 'check' }/>
            }
        </td>
        <td className='text-right'>
            {
                client.hives && client.hives.some(hive => hive.state === 'dead') &&
                    <span className='text-danger'><FontAwesome name={ 'warning' }/> </span>
            }
            { client.hives.length }
        </td>
    </tr>

class Clients extends Component {
    constructor() {
        super()
        this.newClient = this.newClient.bind(this)
        this.redirect = this.redirect.bind(this)
    }

    newClient() {
        this.props.dispatch(ClientsRequest.post.action())
    }

    componentDidMount() {
        this.props.dispatch(ClientsRequest.get.action())
        if (this.props.user && this.props.user.limited)
            window.location = "/"
    }

    redirect(client) {
        this.props.dispatch(setCurrentClient(client._id))
        browserHistory.push(makeEndpoint(URLS.client.show, client))
    }

    _isActiveClient(client) {
        return this.props.params.id && this.props.client.current && client._id === this.props.client.current._id
    }

    updateClient(values, dispatch) {
        console.log(values)
    }

    search(data) {
        if (data && data.value) {
            this.props.dispatch(setCurrentClient(data.value))
            browserHistory.push(makeEndpoint(URLS.client.show, { id: data.value }))
        } else {

            browserHistory.push(makeEndpoint(URLS.client.index))
        }
        this.props.dispatch(clientSearchChange({ search: data ? data : null }))
    }

    render() {
        return (
            <div>
                <div className='row'>
                    <div className='col-md-12'>
                        <h4 className='page-title'>
                            Clients
                            <small> Gestion des clients et des ruches</small>
                            <div className='pull-right m-t-25'>
                                <a className='btn btn-success waves-effect' onClick={ this.newClient }>
                                    Nouveau client
                                </a>
                            </div>
                        </h4>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-4 col-sm-4'>
                        <Select
                            className='m-b-10'
                            name='search'
                            value={ this.props.client.search }
                            placeholder='Search...'
                            options={ getSelectReportsOptions(this.props.client.all) }
                            onChange={ this.search.bind(this) }
                            noResultsText='Not found.'
                        />

                        <div className='card-box table-list'>
                            <table className='table table-striped m-0 header-fixed'>
                                <thead>
                                    <tr>
                                        <th>Nom</th>
                                        <th style={ { width: '30px' } }>Adresse</th>
                                        <th style={ { width: '30px' } }>Email</th>
                                        <th className='text-right' style={ { width: '50px' } }>Ru.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        getClientsByFilters(this.props.client.all, this.props.client.search ? this.props.client.search.value : null).map((client) =>
                                            <Client
                                                client={ client }
                                                key={ client._id }
                                                redirect={ this.redirect }
                                                active={ this._isActiveClient(client) }
                                            />
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='col-md-8 col-sm-8'>
                        <div className='card-box'>
                            { this.props.children }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Clients.preload = () => [[getClientsSaga.start]]

Clients.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    const { client, session } = state
    return {
        client,
        user: session.user
    }
}

export default connect(mapStateToProps)(Clients)


// WEBPACK FOOTER //
// ./src/client/features/client/containers/Clients.jsx